import { formatString } from "@/helpers/formatting";
import { axiosClient } from "@/services/client";
import endpoints from "@/services/endpoints";

import type { IPaginatedResponse, ParamRecord } from "@/models/common";
import type {
  TwilioAssignmentPayload,
  TwilioPhoneNumber,
} from "@/models/twilio";

class TwilioApiService {
  async getAvailablePhoneNumbers(params: ParamRecord) {
    const response = await axiosClient.get<
      IPaginatedResponse<TwilioPhoneNumber>
    >(endpoints.TWILIO.PHONE_NUMBER_MANAGEMENT.AVAILABLE, {
      params,
    });
    return response.data;
  }

  async getUserAssignedTwilioPhoneNumbers(userId: number) {
    const response = await axiosClient.get<{ data: TwilioPhoneNumber[] }>(
      formatString(endpoints.TWILIO.PHONE_NUMBER_MANAGEMENT.ASSIGNED, userId)
    );
    return response.data;
  }

  async updateUserAssignedPhoneNumbers(payload: TwilioAssignmentPayload) {
    await axiosClient.post(
      endpoints.TWILIO.PHONE_NUMBER_MANAGEMENT.MANAGE,
      payload
    );
  }
}

const twilioApiService = new TwilioApiService();
export default twilioApiService;
